import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import messages from '../../../../text/messages';

class UnderReview extends React.Component {
    constructor(props) {
        super(props);

        this.renderProgressTable = this.renderProgressTable.bind(this);
        this.renderProgressExplanation = this.renderProgressExplanation.bind(this);
    }

    getSymbol(status) {
        switch (status) {
            case 'done':
                return <i className="material-icons">check_circle</i>;
            case 'inProgress':
                return <i className="material-icons">info</i>;
            case 'failed':
                return <i className="material-icons material-icons-red">highlight_off</i>;
            case 'next':
                return <div className="empty-circle" />;
            default:
                return '';
        }
    }

    renderRow(message, status, values) {
        return (
            <div className="col-xs-12">
                <div className={`underReview-infoItem ${status}`}>
                    {this.getSymbol(status)}
                    <span>
                        <FormattedMessage {...message} values={values} />
                    </span>
                </div>
            </div>
        );
    }

    renderProgressExplanation() {
        const { progress } = this.props;

        switch (progress.branch) {
            case 'dont-qualify-ic':
            default:
                return (
                    <FormattedHTMLMessage
                        id={'onboarding.underReview'}
                        defaultMessage={`We're reviewing the information you submitted about your business.<br/>You'll hear from us as soon as we have completed the review.`}
                        tagName="p"
                    />
                );
        }
    }

    renderProgressTable() {
        const { admin, progress } = this.props;
        const adminName = (admin && admin.name) || 'GreenLight';

        switch (progress.branch) {
            case 'dont-qualify-ic':
                return (
                    <div className="underReview-itemsWrapper">
                        {this.renderRow(messages.createdAccount, 'done')}
                        {this.renderRow(messages.submittedBusinessDocs, 'failed')}
                        {this.renderRow(messages.approvalUnderway, 'inProgress', { admin: adminName })}
                        {this.renderRow(messages.signICAgreement, 'next')}
                        {this.renderRow(messages.approvedToStart, 'next')}
                    </div>
                );

            default:
                return (
                    <div className="underReview-itemsWrapper">
                        {this.renderRow(messages.createdAccount, 'done')}
                        {this.renderRow(messages.submittedBusinessDocs, 'done')}
                        {this.renderRow(messages.approvalUnderway, 'inProgress', { admin: adminName })}
                        {this.renderRow(messages.signICAgreement, 'next')}
                        {this.renderRow(messages.approvedToStart, 'next')}
                    </div>
                );
        }
    }

    render() {
        const { admin } = this.props;

        return (
            <div className="underReview">
                <div className="hidden-xs col-sm-1" />
                <div className="col-xs-12 col-sm-10">
                    <div className="underReview-content">
                        <div className="underReview-title">
                            <FormattedMessage {...messages.underReviewTitle} />
                        </div>
                        <div className="row section">
                            <div className="col-xs-12">
                                <div className="underReview-message">{this.renderProgressExplanation()}</div>
                                {this.renderProgressTable(admin)}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hidden-xs col-sm-1" />
            </div>
        );
    }
}

const mapStateToProps = state => {
    let admin = state.onboarding.admin;
    return { admin };
};

export default connect(mapStateToProps, null)(UnderReview);



// WEBPACK FOOTER //
// ./src/pages/dashboard/components/underReview/index.jsx